export default __webpack_public_path__ + "static/media/metamask.b6b09bd4.svg";